import { debounce } from '@mui/material/utils'
import {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react'

import { useLiquidityPoolsInfinite } from '@/hooks/use-nemo-apis'

import { PoolDataInfinite } from './types'
import View from './view'

let debounceFn: any

const Container = () => {
  const [inputValue, setInputValue] = useState<string>('')
  const [keyword, setKeyword] = useState('')

  const {
    data: poolsFromBE,
    isFetching: isFetchingPools,
    fetchNextPage: fetchPoolsNextPage,
  } = useLiquidityPoolsInfinite(keyword)

  const fetch = useMemo(
    () =>
      debounceFn = debounce(
        (request: { input: string }) => {
          setKeyword(request.input)
        },
        400,
      ),
    [],
  )

  useEffect(() => {
    if (debounceFn) {
      debounceFn.clear()
    }

    if (inputValue) {
      fetch({ input: inputValue })
    } else {
      setKeyword('')
    }
  }, [inputValue, fetch])

  const fetchNextPage = useCallback(() => {
    if (!poolsFromBE?.pages[poolsFromBE.pageParams.length - 1].has_next_page) return

    fetchPoolsNextPage()
  }, [fetchPoolsNextPage, poolsFromBE?.pageParams.length, poolsFromBE?.pages])

  const isEmptyPools = useCallback((poolsData: PoolDataInfinite | undefined) => {
    if (!poolsData) return true
    if (poolsData.pages.length === 1 && poolsData.pages[0].pools.length === 0) return true

    return false
  }, [])

  const computedProps = {
    poolsData: poolsFromBE,
    inputValue,
    setInputValue,
    isLoading: isFetchingPools,
    fetchNextPage: fetchNextPage,
    isEmptyPools,
  }

  return <View {...computedProps} />
}

export default Container
